import type { Guide } from "./guide";

export const tutorial: Guide = {
  name: "User Interface in CREATE Web",
  internal: "obt01",
  steps: [
    {
      target: ".v-step-0",
      content: "This is your canvas, and it shows your statechart. Here is an initial example.",
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const stName = document.getElementsByClassName("canvas-step")[0];
          stName.classList.add("v-step-0");
          resolve();
        }),
      params: {
        placement: "bottom",
        strategy: "fixed",
      },
    },
    {
      target: ".v-step-1",
      content: "This is the statechart name. You can modify it according to its purpose.",
      before: (type) =>
        new Promise<void>((resolve, reject) => {
          const stName = document.getElementsByClassName("guide-statechart-name")[0];
          stName.classList.add("v-step-1");
          resolve();
        }),
    },
    {
      target: ".v-step-2",
      content:
        '<video src="/videos/obt1/stencil-drag.webm" type="video/webm" autoplay muted loop></video><br />This is the palette and you can drag elements from here to the canvas.',
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const stencilContainer = document.getElementsByClassName("stencil-container")[0];
          stencilContainer.classList.add("v-step-2");
          resolve();
        }),
      params: {
        placement: "left",
      },
    },
    {
      target: ".v-step-3",
      content: "Statechart Definitions shows the statechart interface. Here a single event named 'myEvent' is defined.",
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const propertiesContainer = document.getElementsByClassName("guide-statechart-definitions-container")[0];
          propertiesContainer.classList.add("v-step-3");
          resolve();
        }),
      params: {
        placement: "right",
      },
    },
    {
      target: ".v-step-3",
      content: "The event 'myEvent' is used as a trigger to change from one state to the next one.",
      params: {
        placement: "right",
      },
    },
    {
      target: ".v-step-5",
      content: "For larger statecharts, you may use the minimap to select the viewport.",
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const minimapContainer = document.getElementsByClassName("guide-minimap-container")[0];
          minimapContainer.classList.add("v-step-5");
          resolve();
        }),
      params: {
        placement: "top",
      },
    },
    {
      target: ".v-step-6",
      content: "The properties view shows details of a selected element. You can modify these details here.",
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const propertiesContainer = document.getElementsByClassName("guide-properties-container")[0];
          propertiesContainer.classList.add("v-step-6");
          resolve();
        }),
      params: {
        placement: "right",
      },
    },
    {
      target: ".v-step-7",
      content: "You can simulate the statechart using the toolbar here.",
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const playerContainer = document.getElementsByClassName("guide-player-container")[0];
          playerContainer.classList.add("v-step-7");
          resolve();
        }),
      params: {
        placement: "bottom",
      },
    },
    {
      target: ".v-step-8",
      content: "You can generate code for various target languages.",
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const genCode = document.getElementsByClassName("mdi-code-tags")[0];
          genCode.classList.add("v-step-8");
          resolve();
        }),
      params: {
        placement: "bottom",
      },
    },
  ],
};
